import { registerNewReport } from 'actions/ui/app'
import queryClientRegistry from 'utilities/queryClientRegistry'
import storeRegistry from 'utilities/storeRegistry'

import { invalidateReportsDownloadsQueries } from './invalidateReportsDownloadsQueries'
import {
    type NotifyAsyncExportStartedOptions,
    reportFromExportData,
} from './reportFromExportData'
import { showAsyncExportToast } from './showAsyncExportToast'

export type { NotifyAsyncExportStartedOptions } from './reportFromExportData'

export function notifyAsyncExportStarted({
    reportName,
    report: reportData,
    description,
}: NotifyAsyncExportStartedOptions): void {
    const queryClient = queryClientRegistry.getClient()
    if (queryClient) {
        void invalidateReportsDownloadsQueries(queryClient)
    }

    const report = reportFromExportData(reportData)
    if (report) {
        storeRegistry.dispatch(registerNewReport(report))
    }

    showAsyncExportToast(reportName, description)
}
